import { Outlet } from 'react-router-dom';
import {
    NavLink as RouterLink,
    matchPath,
    useLocation,
    useNavigate
} from 'react-router-dom';
import { AppBar, experimentalStyled, Toolbar, Typography } from '@mui/material';
import MainNavbar from './MainNavbar';
import Footer from "./Footer";
import Button from "./Button";
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { GoogleReCaptchaProvider } from 'react-google-recaptcha-v3';

import Loading from "./Loading"


const MainLayoutRoot = experimentalStyled('div')(
    ({ theme }) => ({
        backgroundColor: theme.palette.background.paper,
        display: 'flex',
        height: '100%',
        overflow: 'hidden',
        width: '100%'
    })
);
const MainLayoutWrapper = experimentalStyled('div')({
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden',
    paddingTop: 64
});
const MainLayoutContainer = experimentalStyled('div')({
    display: 'flex',
    flex: '1 1 auto',
    overflow: 'hidden'
});
const MainLayoutContent = experimentalStyled('div')({
    flex: '1 1 auto',
    height: '100%',
    overflow: 'auto'
});
const MainLayout = () => {
    const navigate = useNavigate();
    const user = useSelector((state) => state?.auth);
    const Start = useSelector((state) => state.Start);
    let location = useLocation()
    useEffect(() => {
        if (location.pathname === "/consent") {
            if (user?.isLoggedIn === undefined || user?.isLoggedIn === null || user?.isLoggedIn === false) {
                console.log('Navigate', 10);
                //navigate('/' + localStorage.getItem("site"), { replace: false });
                window.location.href = '/' + localStorage.getItem("site")
            } else if (user?.user?.reset_password === true) {
                navigate('/reset-new-password', { replace: false });
            } else if (user?.user?.change_password === true) {
                navigate('/set-new-password', { replace: false });
            } else if (user?.user?.consent === true) {
                navigate('/kpi/home', { replace: false });
            }
        }
    }, [])
    return (
        // <GoogleReCaptchaProvider
        //     reCaptchaKey={Start?.recaptchaKey || ""}
        // >
            <MainLayoutRoot>
                <Loading />
                <MainNavbar />
                <MainLayoutWrapper>
                    <MainLayoutContainer>
                        <MainLayoutContent>
                            <Outlet />
                            {/*<Footer/>*/}
                        </MainLayoutContent>
                    </MainLayoutContainer>
                </MainLayoutWrapper>
            </MainLayoutRoot>
        // </GoogleReCaptchaProvider>
    );
}
export default MainLayout;
